export default __webpack_public_path__ + "static/VikrantAbrol-bf695952e8504179bbed8b90d9e98fb5.jpeg";